export enum TipoOperadorEnum { UNARIO, BINARIO }
